<template>
  <span class="h3">Edit auction</span>
  <AuctionList v-if="!store.live_auction"></AuctionList>
  <AuctionData v-else></AuctionData>
</template>
<script setup>
import AuctionList from "@/components/auctioneer/setup/AuctionList.vue";
import AuctionData from "../edit/AuctionData.vue";
import { useStore } from "@/store/index";
const store = useStore();
</script>
